import {
  ADD_COURSE_TO_CART_FAILURE,
  ADD_COURSE_TO_CART_REQUEST,
  ADD_COURSE_TO_CART_SUCCESS,
  DELETE_COURSE_FROM_CART_FAILURE,
  DELETE_COURSE_FROM_CART_REQUEST,
  DELETE_COURSE_FROM_CART_SUCCESS,
  GET_CART_DETAIL_FAILURE,
  GET_CART_DETAIL_REQUEST,
  GET_CART_DETAIL_SUCCESS,
  GET_COURSES_FROM_CART_FAILURE,
  GET_COURSES_FROM_CART_REQUEST,
  GET_COURSES_FROM_CART_SUCCESS,
  RESET_ADD_COURSE_TO_CART,
  RESET_ALL_ACTIONS,
  RESET_REMOVE_COURSE_FROM_CART,
} from "./ActionType";

const initialState = {
  addCourseToCartResult: {},
  removeCourseFromCartResult: {},
  courseIds: [],
  cartDetail: null,
  isLoading: false,
  error: null,
  errorCartDetail: null,
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COURSE_TO_CART_REQUEST:
    case DELETE_COURSE_FROM_CART_REQUEST:
    case GET_COURSES_FROM_CART_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_CART_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
        errorCartDetail: null,
      };
    case ADD_COURSE_TO_CART_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        addCourseToCartResult: action.payload,
      };
    case GET_CART_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorCartDetail: null,
        cartDetail: action.payload,
      };
    case ADD_COURSE_TO_CART_FAILURE:
    case DELETE_COURSE_FROM_CART_FAILURE:
    case GET_COURSES_FROM_CART_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        cartDetail: null,
      };
    case GET_CART_DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorCartDetail: action.payload,
      };

    case DELETE_COURSE_FROM_CART_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        removeCourseFromCartResult: action.payload,
      };
    case RESET_ADD_COURSE_TO_CART:
      return {
        ...state,
        addCourseToCartResult: {},
      };

    case RESET_REMOVE_COURSE_FROM_CART:
      return {
        ...state,
        removeCourseFromCartResult: {},
      };
    case GET_COURSES_FROM_CART_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        courseIds: action.payload,
      };
    default:
      return state;
  }
};
